import * as React from "react"
import { cn } from "@/lib/utils"

/**
 * The mark at the top of every client-facing document.
 *
 * Premium plans are white-labeled: the freelancer's own logo (or business
 * name) replaces the FlowLancer badge entirely. On every other plan the badge
 * stays, which is what makes each sent document an acquisition surface.
 *
 * `white_label` and `logo_url` are decided server-side in public.ts — the
 * client never gets a logo it is not entitled to render.
 */
function DocumentMark({ freelancer, className, ...props }) {
  const whiteLabel = !!freelancer?.white_label
  const logo = freelancer?.logo_url
  const label = freelancer?.business_name || freelancer?.name || ""

  if (whiteLabel) {
    return (
      <div className={cn("flex items-center gap-2", className)} {...props}>
        {logo
          ? <img src={logo} alt={label} className="h-8 max-w-[180px] object-contain object-left" />
          : <span className="font-display text-subhead text-ink">{label}</span>}
      </div>
    )
  }

  return (
    <div className={cn("flex items-center gap-2", className)} {...props}>
      <img src="/logo192.png" alt="" className="h-6 w-6 rounded-md" />
      <span className="text-micro uppercase text-ink-subtle">Powered by FlowLancer</span>
    </div>
  )
}

export { DocumentMark }
